import React, { useMemo, useState } from 'react';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { Video } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { LayoutEditComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutEditComponentListItem';
import { WebsiteEditorVideoComponentFragment } from '@graphql/generated';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { VideoProps } from '../../Video';
import { VIDEO_ACTIONS } from '../../Video.constants';
import { getVideoDataFromUrl } from '../../Video.utils';
import { TextV2 } from '@withjoy/joykit';

export const VideoEditListItem: React.FC<VideoProps> = props => {
  const { componentData, isLastItem, sortable } = props;
  const [isHover, setIsHover] = useState(false);
  const { t } = useTranslation('websiteEditor');
  const { navigateToScreen } = useNavigationPaneContext();
  const { setCustomComponentBlockData, setShowDeletePopup, setDeleteComponentDetails } = useCustomComponentStateContext<WebsiteEditorVideoComponentFragment>();
  const videoTrans = t('customPage', 'video');

  const handleEdit = useEventCallback(() => {
    setCustomComponentBlockData(componentData);
    navigateToScreen(VIDEO_ACTIONS.VIDEO_EDIT);
  });

  const handleDeleteClick = useEventCallback(() => {
    if (componentData?.id) {
      setShowDeletePopup(true);
      setDeleteComponentDetails({
        id: componentData.id,
        title: videoTrans.deleteTitle(),
        subTitle: videoTrans.deleteSubtitle(),
        deleteCta: videoTrans.deleteCta(),
        cancelCta: videoTrans.cancelCta(),
        successMessage: videoTrans.deleteComponentSuccess(),
        errorMessage: videoTrans.deleteComponentError(),
      });
    }
  });

  const thumbnailUrl = useMemo(() => {
    const videoData = getVideoDataFromUrl(componentData?.videoUrl || '');
    return videoData?.thumbnailUrl ? [videoData?.thumbnailUrl] : [];
  }, [componentData]);

  return (
    <LayoutEditComponentListItem
      title={<TextV2 typographyVariant="button2">{videoTrans.videoCardHeader()}</TextV2>}
      isDragActive={sortable?.isDragActive ?? false}
      dragItemId={sortable?.dragItemId ?? ''}
      isLastItem={isLastItem}
      height={sortable?.itemSize}
      itemId={componentData.id}
      icon={<Video size={32} />}
      isHover={isHover}
      setIsHover={setIsHover}
      handleEdit={handleEdit}
      handleDelete={handleDeleteClick}
      thumbnailUrls={thumbnailUrl}
      cardPaddingY={5}
    />
  );
};
